<!--ASIGNATURAS-->
<h1 class="d_subtitulo">{{asignaturas_label}}</h1>
<div class="d_principalin">
    <ng-container>
        <ng-container *ngFor="let asignatura of asignaturas_list">
            <div class="d_galeria_asignaturas {{asignatura.clase}}" (click)="asignatura.action && asignatura.action()">
                <img [src]="asignatura.icon"/>
                <p class="galeria__texto">{{ asignatura.label }}</p>
            </div>
        </ng-container>
    </ng-container>
</div>

